export const useSiteLayout = () => {
    const mobileMenuOpen = useState<boolean>('mobileMenuOpen', () => false);
    const mobileMenuUntilBreakpoint = useRuntimeConfig().public.ui.breakpoints.laptop.width;
    const isMobileUi = useState<boolean>('isMobileUi', () => false);
    const handleResize = () => {
        isMobileUi.value = window.innerWidth < mobileMenuUntilBreakpoint;
        if (window.innerWidth >= mobileMenuUntilBreakpoint) {
            mobileMenuOpen.value = true;
        }
    };
    let resizeTimeout: ReturnType<typeof setTimeout>;
    const debouncedResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 150);
    };
    onMounted(() => {
        handleResize(); // Check initial size
        window.addEventListener('resize', debouncedResize);
    });
    onBeforeUnmount(() => {
        window.removeEventListener('resize', debouncedResize);
        clearTimeout(resizeTimeout);
    });
    return {
        mobileMenuOpen,
        isMobileUi
    }
}